import React from "react";

import {Modal} from "react-bootstrap";
import Button from "components/Button";
import {IoClose} from "react-icons/io5";


export const ModalApp = ({show, handleModal, isMap = false, children, label = '', subtitle = '', customHeader = null, hideClose = false}) => {
    return  <Modal
        centered={true}
        show={show}
        onHide={ handleModal }
        backdrop="static"
        keyboard={false}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        className={`rounded-0 ${isMap && 'p-0'} `}
    >
        <Modal.Header className={"custom-modal-header"} style={customHeader ? {backgroundColor: '#f4f4f4', padding: '24px'} : {}}>
            {customHeader ? (
                <>
                    <div style={{display: 'flex', flexDirection: 'column', gap: '4px', flex: 1}}>
                        <span style={{color: 'var(--title-color)', fontWeight: 600, fontSize: '18px', textAlign: 'left'}}>{label}</span>
                        {subtitle && <span style={{color: 'var(--text-color)', fontSize: '12px', textAlign: 'left'}}>{subtitle}</span>}
                    </div>
                    {!hideClose && <IoClose onClick={handleModal} style={{cursor: 'pointer', fontSize: '20px', color: 'var(--text-color)', flexShrink: 0}}/>}
                </>
            ) : (
                <>
                    <span style={{color: 'var(--title-color)', fontWeight: 'bold', textAlign: 'left', flex: 1}}>{label}</span>
                    {!hideClose && <IoClose onClick={handleModal} style={{cursor: 'pointer', fontSize: '24px', color: 'var(--text-color)', flexShrink: 0}}/>}
                </>
            )}
        </Modal.Header>
        <Modal.Body className={`text-center p-0 m-0`}>
            {children}

            {isMap &&
                <div className="mx-3 position-relative">
                    <Button onClick={handleModal} className="close-button-bottom">Fechar</Button>
                </div>
            }
        </Modal.Body>
    </Modal>
}

